export const iconFontAwesomeTravelHotelCableCar = (
	<i className="fa-solid fa-cable-car"></i>
);
